import Logo from '@src/components/Header/Logo'
import Menu from '@src/components/Header/Menu'
import { MenuItem } from '@src/components/Header/MenuItem'
import { getModalIsVisible } from '@src/state/modals/selectors'
import {
  BIBME,
  CITATION_MACHINE,
  EASYBIB,
  SiteConfig,
  SiteState,
} from '@src/state/site/types'
import { RootState } from '@src/state/types'
import {
  HEADER_LEFT_NAV,
  HEADER_LEFT_NAV_DROPDOWN,
  HEADER_LEFT_NAV_MENU,
} from '@src/utils/dataTestIds'
import * as React from 'react'
import { connect } from 'react-redux'
import styled, { css } from 'styled-components'
import PapersCTA from './PapersCTA'

import { getLoggedIn } from '@src/state/auth/selectors'
import { onClickNavLink } from '@src/state/document/actions'
import { getSiteConfig } from '@src/state/site/selectors'
import { Dispatch } from 'redux'
import { topNavRoutes } from './routes'
import TopNavHeader from './TopNavHeader'
import { getTopLeftMenuItems } from './utils'

interface LeftMenuProps {
  active: boolean
}
const MenuLeft = styled(Menu)<LeftMenuProps>`
  ${({ active }) =>
    active
      ? css`
          display: block;
        `
      : null}
  left: 4px;
  &:before {
    left: 10px;
  }
  &:after {
    left: 10px;
  }
`

const Left = styled.div`
  display: flex;
  align-items: center;
  flex: 1;
`

export const HamburgerMenu = styled.button<{ disabled: boolean; site: SiteState }>`
  border: 0;
  background-color: transparent;
  position: relative;
  top: 5px;
  line-height: 0;
  font-size: 0;
  color: transparent;
  display: inline-block;
  width: 48px;
  height: 55px;
  z-index: 2;
  &:hover {
    cursor: pointer;
  }
  &:hover + ${MenuLeft} {
    ${({ disabled }) => (disabled ? 'pointer-events: none' : null)};
  }
  &:before {
    content: '';
    position: absolute;
    top: 14px;
    left: 14px;
    width: 20px;
    height: 2px;
    font-size: 20px;
    background: ${props =>
      props.site === BIBME ? props.theme.colors.white : props.theme.colors.grey};
    box-shadow: 0 0.25em 0 0
        ${props =>
          props.site === BIBME ? props.theme.colors.white : props.theme.colors.grey},
      0 0.5em 0 0
        ${props =>
          props.site === BIBME ? props.theme.colors.white : props.theme.colors.grey};
  }
`

interface StateMappedToProps {
  disabled: boolean
  site: SiteState
  loggedIn?: boolean
  siteConfig: SiteConfig
}

interface DispatchProps {
  onClickNavLink: (label: string) => void
}

export const LeftSide: React.FunctionComponent<StateMappedToProps & DispatchProps> = ({
  disabled,
  site,
  loggedIn,
  siteConfig,
  onClickNavLink,
}) => {
  const [menuActive, setMenuActive] = React.useState(false)
  const onClick = (e: React.SyntheticEvent) => setMenuActive(!menuActive)

  const topLeftMenuItems = getTopLeftMenuItems(topNavRoutes, loggedIn, siteConfig, site)

  return (
    <Left>
      {site === EASYBIB && (
        <nav data-test={HEADER_LEFT_NAV} aria-label="main menu">
          <HamburgerMenu
            site={site}
            onClick={onClick}
            disabled={disabled}
            data-test={HEADER_LEFT_NAV_MENU}
            aria-label="open menu"
          />
          <MenuLeft
            active={menuActive}
            data-test={HEADER_LEFT_NAV_DROPDOWN}
            aria-hidden={!menuActive}
          >
            {menuActive &&
              topLeftMenuItems.map(item => (
                <MenuItem
                  item={item}
                  key={item.id}
                  onClick={() => onClickNavLink(item.name)}
                />
              ))}
          </MenuLeft>
        </nav>
      )}
      <Logo />
      {(site === BIBME || site === CITATION_MACHINE) && <PapersCTA site={site} />}
      {site === EASYBIB && <TopNavHeader />}
    </Left>
  )
}

const mapStateToProps = (state: RootState): StateMappedToProps => ({
  disabled: getModalIsVisible(state),
  site: state.site,
  loggedIn: getLoggedIn(state),
  siteConfig: getSiteConfig(state),
})

const mapDispatchToProps = (dispatch: Dispatch): DispatchProps => ({
  onClickNavLink: (label: string) => {
    dispatch(onClickNavLink({ label }))
  },
})

export default connect<StateMappedToProps, DispatchProps>(
  mapStateToProps,
  mapDispatchToProps
)(LeftSide)



// WEBPACK FOOTER //
// ./src/components/Header/LeftSide.tsx